import { axios, createFormData, handleError } from '../axios';

export const updateRobotSetting = (data) => {
  return new Promise((resolve) => {
    axios
      .post('admin/setting/robot/update', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
